export default "__VITE_ASSET__BbayF1Gg__"